import { IGetState, TBoardId, TKanbanCardProperty } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { boardUpdateMeta } from './boardUpdateMeta';

export const boardSetDefaultCardPreviewCustomProperties = (
    boardId: TBoardId,
    defaultCardPreviewCustomProperties: TKanbanCardProperty[],
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(boardUpdateMeta(boardId, { defaultCardPreviewCustomProperties }));
    };
    return action;
}
